/*
 * Purpose: Tenant-scoped workflow share links (local — not cloud team sync)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 88
 */
import { tenantStorageKey } from '@/lib/tenantStorage';
import { flowsHref } from '@/lib/appRoutes';

export interface WorkflowShareRecord {
  id: string;
  workflowId: string;
  workflowName: string;
  sharedWith: string[];
  permission: 'view' | 'edit' | 'admin';
  sharedAt: string;
  link?: string;
}

const SUFFIX = 'workflow_shares';

function storageKey(): string {
  return tenantStorageKey(SUFFIX);
}

export function loadWorkflowShares(): WorkflowShareRecord[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(storageKey());
    if (!raw) return [];
    const parsed = JSON.parse(raw) as WorkflowShareRecord[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveWorkflowShares(shares: WorkflowShareRecord[]): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(storageKey(), JSON.stringify(shares));
}

export function buildShareLink(workflowId: string): string {
  if (typeof window === 'undefined') return flowsHref(workflowId);
  return `${window.location.origin}${flowsHref(workflowId)}`;
}
